import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../field-interface';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { UnitsService } from 'src/app/services/units.service';
import { Constant } from 'src/app/constant/constant';
import { SpecificationService } from 'src/app/services/specification.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'calsoft-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit {
  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;
  fieldTypeList: any;
  valueSelected: any = null;
  fieldControl: UntypedFormControl = new UntypedFormControl();
  fieldFilterControl: UntypedFormControl = new UntypedFormControl();
  [x: string]: any;

  listOfOptions: any = [];

  url = '';

  constructor(
    private commonService: CommonService,
    private specificationService: SpecificationService,
    private router: Router
  
  ) { 
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  protected _onDestroy = new Subject<void>();
  filteredCustomResourceTypeList: any;
  customResourceTypeList: any;

  customResourceFilterControl: UntypedFormControl = new UntypedFormControl();
  ngOnInit() {
    this.customResourceYFilter();
    this.getAllCustomResource();
    this.value = this.field.eavAttributeOption;
    this.fieldTypeList = this.value;
    this.getAllField();
    this.fielDFilter();

    if (this.field.frontendLabel == 'Custom Product Resource') {
      this.commonService.getCustomResource().subscribe(
        res => {
          this.customResourceTypeList = res;
          this.filteredCustomResourceTypeList = this.customResourceTypeList;
        },
        error => {
        }
      )
    }

    if (this.field.frontendLabel == 'Course Includes') {
      this.specificationService.getAllSpecification().subscribe(
        res => {
          this.customResourceTypeList = res;
          this.filteredCustomResourceTypeList = this.customResourceTypeList;
        },
        error => {
        }
      )
    }

    if (this.field.frontendLabel == 'Amenities') {
      this.specificationService.getAllSpecification().subscribe(
        res => {
          this.customResourceTypeList = res;
          this.filteredCustomResourceTypeList = this.customResourceTypeList;
        },
        error => {
        }
      )
    }

  }



  filterField(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['optionId'] != undefined) {
        filterValue = value['optionId'];
        this.firstFormGroup.patchValue({ optionId: value['optionId'], field: value['optionId'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.fieldTypeList.filter(option =>

      option.eavAttributeOptionValue[0].value.toLowerCase().includes(filterValue));
  }

  getAllField() {
    this.fieldTypeList = this.value;
  }
  fielDFilter() {
    this.fieldFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.fieldFilter();
      });
  }

  protected fieldFilter() {
    if (!this.fieldTypeList) {
      return;
    }
    let search = this.fieldFilterControl.value;
    if (!search) {
      this.fieldTypeList = this.value.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.fieldTypeList = this.value.filter(field => field.eavAttributeOptionValue[0].value.toLowerCase().indexOf(search) > -1)
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  getAllCustomResource() {
    this.filteredCustomResourceTypeList = this.customResourceTypeList;
  }
  customResourceYFilter() {
    this.customResourceFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.resourceFilter();
      });
  }

  protected resourceFilter() {
    if (!this.customResourceTypeList) {
      return;
    }

    // get the search keyword
    let search = this.customResourceFilterControl.value;
    if (!search) {
      this.filteredCustomResourceTypeList = this.customResourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredCustomResourceTypeList = this.customResourceTypeList.filter(customResourceType => customResourceType['value'].toLowerCase().indexOf(search) > -1)
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
